"use client";

import { LocalizationType } from "@/Helpers";
import { useT } from "@/Hooks";
import Breadcrumb from "./Breadcrumb";

interface LocalizedBreadcrumbProps {
  titleKey?: LocalizationType;
  titleFallback: string;
  items?: { key: LocalizationType; fallback: string }[];
  addTitleToEndItems?: boolean;
  showSearchBox?: boolean;
}

const LocalizedBreadcrumb = ({
  titleKey,
  titleFallback,
  items = [],
  addTitleToEndItems,
  showSearchBox,
}: LocalizedBreadcrumbProps) => {
  const t = useT();

  return (
    <Breadcrumb
      title={titleKey ? t(titleKey, undefined, titleFallback) : titleFallback}
      items={items.map((item) => t(item.key, undefined, item.fallback))}
      addTitleToEndItems={addTitleToEndItems}
      showSearchBox={showSearchBox}
    />
  );
};

export default LocalizedBreadcrumb;
